export const tPath = 'alerts.overlay';
